/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useCallback, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdArrowDropDown,
  MdArrowDropUp,
} from 'react-icons/md';

import { AiOutlineDownload } from 'react-icons/ai';

import { CSVLink } from 'react-csv';

import { Pagination, Modal, Row, Col } from 'antd';

import { ClipLoader } from 'react-spinners';

import { IoMdArrowBack, IoMdHelpCircle } from 'react-icons/io';

import Breadcumbs from '~/components/Breadcumbs';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxTitleAlert,
  BoxPagination,
  BoxButtonDownload,
} from './style';
import { catchErros } from '../LinhasDeCuidado/messages';
import iconAlertConfirm from '~/assets/icons/iconAlertConfirm.svg';

import { IdentificadordoPaciente } from '../LinhasDeCuidadoGrid/indentificadorPaciente';
import { pdfErros } from './linksPdf';
import { getTitleIndicador } from '../LinhasDeCuidado/careLinesInfo';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';

const LinhasDeCuidadoErros = props => {
  const { indicador } = props.match.params;

  const [data, setData] = useState([]);

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const { register, handleSubmit } = useForm();

  const { token, cnes } = store.getState().auth;

  const [searchText, setSearchText] = useState();

  const [pageCurrent, setPageCurrent] = useState(1);

  const [indicadorLinhaDeCuidado, SetIndicadorLinhaDeCuidado] = useState('');

  const [linhaDeCuidadoValue, setLinhaDeCuidadoValue] = useState(null);

  const [periodoSelecionado, setPeriodoSelecionado] = useState('');

  const [titlePage, setTitlePage] = useState('');

  const [dataCsvDownload, setDataCsvDownload] = useState(null);

  const [modalCsvDownload, setModalCsvDownload] = useState(false);

  const [lc, setLc] = useState('');

  const limit = 5;

  const [directionAsc, setDirectionAsc] = useState(true);

  const [orderBy, setOrderBy] = useState('');

  const obterErros = async props => {
    const order = props?.orderBy || '';
    const offset = props?.offset || 0;

    const dir = props?.dir;
    const page = props?.currentPage;

    setOrderBy(order);

    setLoading(true);
    try {
      const response = await api.get(
        `indicadores-linhas-de-cuidado/${indicador}/erros-importacao?limit=${limit}&offset=${offset}&periodo=${periodoSelecionado}${order &&
          `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setData(response?.data);
      setTotalCount(response.headers['total-count']);
      if (!page) {
        setPageCurrent(1);
      }

      setLoading(false);
    } catch (error) {
      catchErros(error);
    }
  };

  const paginationChange = async page => {
    setPageCurrent(page);

    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    obterErros({
      orderBy: orderBy,
      offset: offset,
      currentPage: page,
      dir: directionAsc,
    });
  };

  useEffect(() => {
    if (linhaDeCuidadoValue) {
      obterErros();
    }
  }, [linhaDeCuidadoValue]);

  useEffect(() => {
    const nomeIndicador =
      (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
      (indicador === 'artropatia_de_quadril' && 'Quadril') ||
      (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
      (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
      (indicador === 'indicadores_painel_geral' && 'Gerais') ||
      (indicador === 'sepse_e_choque_septico' && 'Sepse') ||
      (indicador === 'sindrome_coronariana_aguda' && 'SCA');

    const indicadorLC =
      (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
      (indicador === 'artropatia_de_quadril' && 'QUA') ||
      (indicador === 'cancer_de_mama' && 'MAM') ||
      (indicador === 'cancer_de_prostata' && 'PRO') ||
      (indicador === 'sepse_e_choque_septico' && 'SEP') ||
      (indicador === 'sindrome_coronariana_aguda' && 'SCA');

    const titleIndicador =
      (indicador === 'indicadores_painel_geral' &&
        'Indicadores do Painel Geral') ||
      (indicador === 'acidente_vascular_cerebral' &&
        'Acidente Vascular Cerebral - AVC') ||
      (indicador === 'artropatia_de_quadril' && 'Artropatia de Quadril') ||
      (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
      (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
      (indicador === 'sepse_e_choque_septico' && 'Sepse e Choque Séptico') ||
      (indicador === 'sindrome_coronariana_aguda' &&
        'Síndrome Coronariana Aguda - SCA');
    SetIndicadorLinhaDeCuidado(nomeIndicador);
    setLinhaDeCuidadoValue(indicador);

    setLc(indicadorLC);

    setTitlePage(titleIndicador);
    if (props.location.state) {
      setPeriodoSelecionado(props.location.state.periodo);
    }
  }, []);

  const downloadCsv = async () => {
    setModalCsvDownload(true);

    try {
      const response = await api.get(
        `/indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/download-csv?periodo=${periodoSelecionado}&tipo=ERROR`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setDataCsvDownload(response.data);
    } catch (error) {
      catchErros(error);

      setModalCsvDownload(false);
    }
  };

  const getErrosPdf = useCallback(() => {
    const { indicador } = props.match.params;
    history.push({
      pathname: `/area-de-suporte`,
      state: {
        searchBy: `${getTitleIndicador(indicador)}`,
      },
    });
  }, []);

  return (
    <>
      <Modal
        title="Baixe os dados no formato .CSV"
        visible={modalCsvDownload}
        onOk={() => {}}
        onCancel={() => setModalCsvDownload(false)}
        centered
        footer={false}
      >
        {dataCsvDownload ? (
          <BoxButtonDownload>
            <CSVLink
              className="botao-verde"
              filename={`${linhaDeCuidadoValue}-${String(
                periodoSelecionado
              ).replace('/', '-')}.csv`}
              data={dataCsvDownload}
            >
              Download do .CSV
            </CSVLink>
          </BoxButtonDownload>
        ) : (
          <BoxButtonDownload>
            <p>Aguarde, carregando...</p>
          </BoxButtonDownload>
        )}
      </Modal>
      <Breadcumbs
        path={`${linhaDeCuidadoValue}`}
        pathTitle={`Adicionar Indicadores de Linhas de Cuidado / ${titlePage}`}
      />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <div>
            <span>Relatório de Inconsistências</span>
            <p>Competência: {periodoSelecionado}</p>
          </div>

          <div className="headerButtons">
            <button type="button" onClick={getErrosPdf}>
              <IoMdHelpCircle size={16} color="#FFF" />
              Documentação de erros
            </button>
            <button type="button" onClick={downloadCsv}>
              <AiOutlineDownload size={16} color="#FFF" />
              Exportar .csv
            </button>
          </div>
        </div>
      </PageTitle>

      {!loading && data.length > 0 ? (
        <BoxContent>
          <BoxTitleAlert>
            <img src={iconAlertConfirm} alt="ENVIO RECUSADO" />
            <h2>ENVIO RECUSADO</h2>

            <div className="alertBox">
              <p>
                Favor revisar e corrigir os dados abaixo para que a plataforma
                possa aceitar o documento submetido.
              </p>
            </div>
          </BoxTitleAlert>

          <BoxContentHeader>
            <Row>
              <Col span={2}>
                <ButtonOrderBy
                  isError
                  isActive={orderBy === 'numeroRegistro'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    obterErros({
                      orderBy: 'numeroRegistro',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span className="nomeArquivoHeader">
                    Linha <br />
                    do CSV
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={3}>
                <ButtonOrderBy
                  isError
                  isActive={orderBy === 'identificadorDoPaciente'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    obterErros({
                      orderBy: 'identificadorDoPaciente',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span className="nomeArquivoHeader">
                    Número
                    <br />
                    do registro
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={5}>
                <ButtonOrderBy
                  isError
                  isActive={orderBy === 'identificadorDoPaciente'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    obterErros({
                      orderBy: 'identificadorDoPaciente',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span className="nomeArquivoHeader">
                    Identificador <br />
                    do paciente
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>
              <Col span={5}>
                <span>Variável</span>
              </Col>

              <Col span={3}>
                <span>Valor</span>
              </Col>
              <Col span={5}>
                <span>Descrição do erro</span>
              </Col>
            </Row>
          </BoxContentHeader>

          {data.map(
            (
              {
                descricaoErro,
                numeroRegistro,
                identificadorDoPaciente,
                valor,
                variavel,
              },
              id
            ) => {
              const idPaciente =
                IdentificadordoPaciente(
                  {
                    linhaDeCuidadoValue: 'dados_faltantes',
                    lc,
                    cnes,
                    identificadorDoPaciente,
                  },
                  periodoSelecionado
                ) || '';

              return (
                <BoxList key={Number(id)}>
                  <Row>
                    <Col span={2}>
                      <div className="boxFirst">
                        <span>{numeroRegistro || ' - '}</span>
                      </div>
                    </Col>

                    <Col span={3}>
                      <div className="boxFirst">
                        <span>{identificadorDoPaciente || ' - '}</span>
                      </div>
                    </Col>

                    <Col span={5}>
                      <div className="boxInner">
                        <span>
                          {identificadorDoPaciente ? idPaciente : ' - '}
                        </span>
                      </div>
                    </Col>

                    <Col span={5}>
                      <div className="boxInner">
                        <span>{variavel || ''}</span>
                      </div>
                    </Col>

                    <Col span={3}>
                      <div className="boxInner">
                        <span>{valor || ''}</span>
                      </div>
                    </Col>

                    <Col span={5}>
                      <div className="boxInner">
                        <span>{descricaoErro || ''}</span>
                      </div>
                    </Col>
                  </Row>
                </BoxList>
              );
            }
          )}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};
export default LinhasDeCuidadoErros;
